import { render, staticRenderFns } from "./SideRight_Member_List.vue?vue&type=template&id=81be0b88"
import script from "./SideRight_Member_List.vue?vue&type=script&lang=js"
export * from "./SideRight_Member_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports